<div class="tw-bg-white tw-flex tw-flex-col tw-rounded-[11px] tw-py-[30px] tw-font-body">
    <div class="bold">
        <span class="tw-flex tw-items-center tw-mx-[-15px]">
            <img class="tw-w-[43.5%] tw-mr-[5px]"
                [src]='oldProduct.rebrandedImageWithBackground && oldProduct.rebrandedImageWithBackground?.length ? oldProduct.rebrandedImageWithBackground[oldProduct?.rebrandedImageWithBackground?.length - 1] : false || oldProduct?.productUnboxedImage[oldProduct.productUnboxedImage.length - 1] || oldProduct?.images[oldProduct.images.length - 1]' />
            <div class="tw-absolute tw-left-[40%] tw-rounded-full tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-white tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
                <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]="'arrow_right'"></cs-icon>
            </div>
            <img class="tw-w-[54.5%]" [src]='newProduct?.rebrandedImageWithBackground && newProduct?.rebrandedImageWithBackground.length ? newProduct.rebrandedImageWithBackground[newProduct?.rebrandedImageWithBackground.length - 1] : false || newProduct?.productUnboxedImage[newProduct?.productUnboxedImage.length - 1] || newProduct?.images[newProduct?.images.length - 1]' />
        </span>
        <div class="tw-pt-2 tw-pr-0 tw-pb-6 tw-text-center" *ngIf="oldProduct && newProduct" i18n="@@isUpgradedTo">
            <div class="tw-text-600">
                {{oldProduct?.title || oldProduct?.hiddenTitle}}
            </div>
            <div class="tw-text-600">&nbsp;is upgraded to</div>
            <div class="tw-text-600 tw-font-bold">
                &nbsp;{{newProduct?.title || newProduct?.hiddenTitle}}
            </div>
        </div>
    </div>

    <div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-3 tw-px-[10px]">
      <div
        (click)="changeProduct.emit()"
        class="tw-p-2 tw-px-4 tw-flex-1 tw-max-w-max tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-1 tw-text-white tw-font-bold tw-text-200 tw-bg-teal-600 tw-rounded-2"
      >
        <span i18n="@@addToCart">Add to Cart</span>
      </div>
      <div
        class="tw-p-2 tw-px-4 tw-flex-1 tw-max-w-max tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-1 tw-font-bold tw-text-200 tw-text-teal-600 tw-border tw-border-teal-600 tw-rounded-2"
           (click)="articleOpen.emit()">
        <span i18n="@@readMore">Read More</span>
      </div>
    </div>

</div>
